import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';
import { Modal } from './Modal';
import { Button } from './Button';

export const DeleteConfirmation = ({
  open,
  onClose,
  onConfirm,
  title = 'Delete Item',
  message = 'Are you sure you want to delete this item? This action cannot be undone.',
  confirmText = 'Delete',
  cancelText = 'Cancel',
  itemName,
}) => {
  return (
    <Modal open={open} onClose={onClose} size="md" className="max-w-md">
      <div className="flex flex-col items-center text-center">
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-error/10">
          <AlertTriangle className="h-8 w-8 text-error" />
        </div>

        <h3 className="mb-2 text-lg font-semibold text-text-primary">{title}</h3>

        <p className="mb-6 text-sm text-text-secondary">
          {message}
          {itemName && (
            <span className="mt-2 block font-medium text-text-primary">"{itemName}"</span>
          )}
        </p>

        <div className="flex w-full gap-3">
          <Button variant="outline" onClick={onClose} className="flex-1">
            {cancelText}
          </Button>
          <Button variant="destructive" onClick={onConfirm} className="flex-1">
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
